var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99416 8L9.00916 2.985C9.27302 2.71957 9.42111 2.36051 9.42111 1.98625C9.42111 1.61199 9.27302 1.25293 9.00916 0.987499C8.87746 0.854717 8.72078 0.749324 8.54814 0.677402C8.37551 0.60548 8.19034 0.568451 8.00333 0.568451C7.81631 0.568451 7.63114 0.60548 7.45851 0.677402C7.28587 0.749324 7.12919 0.854717 6.99749 0.987499L0.990825 6.99416C0.858043 7.12586 0.752651 7.28255 0.680729 7.45518C0.608807 7.62781 0.571777 7.81298 0.571777 8C0.571777 8.18702 0.608807 8.37218 0.680729 8.54482C0.752651 8.71745 0.858043 8.87413 0.990825 9.00583L6.99749 15.0833C7.12987 15.2146 7.28686 15.3185 7.45946 15.389C7.63206 15.4595 7.81688 15.4952 8.00333 15.4942C8.18977 15.4952 8.37459 15.4595 8.54719 15.389C8.7198 15.3185 8.87679 15.2146 9.00916 15.0833C9.27302 14.8179 9.42111 14.4588 9.42111 14.0846C9.42111 13.7103 9.27302 13.3513 9.00916 13.0858L3.99416 8Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.546c2e0d2272996aa030f7cfd98a5099.svg";
export { ForwardRef as ReactComponent };